export default __webpack_public_path__ + "static/media/award-short.5bc2936d.png";